module.exports = __webpack_public_path__ + "img/logo-sq.3568c7ea.jpeg";